/* eslint-disable react/display-name */
import { maxDescriptorDistance } from "globalData";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GET_ALL_FACE_PHOTO_REQUESTED } from "redux/actions";
import { GET_FACE_PHOTO_REQUESTED } from "redux/actions";

import { createMatcher } from "../../faceUtil";

import ProcessFaceRecognition from "./ProcessFaceRecognition";

export default (props) => {
  const threshold = maxDescriptorDistance;

  const dispatch = useDispatch();

  const [facePhotos, setFacePhotos] = useState([]);
  const [faceMatcher, setFaceMatcher] = useState(null);

  const data = useSelector((state) => state.face.allfacePhotos);

  useEffect(() => {
    dispatch({ type: GET_ALL_FACE_PHOTO_REQUESTED });
  }, []);
  useEffect(() => {
    if (data) {
      // eslint-disable-next-line no-unused-expressions
      data?.matcher?.facePhotos?.forEach((photo) =>
        setFacePhotos((prevState) => [...prevState, photo])
      );
    }
  }, [data]);

  useEffect(() => {
    async function matcher() {
      //check there should be at least one matcher
      if (data && facePhotos?.length > 0) {
        const validMatcher = facePhotos;

        const profileList = await createMatcher(validMatcher, threshold);
        setFaceMatcher(profileList);
      }
    }

    if (!!data) {
      matcher();
    }
  }, [data, facePhotos, threshold]);
  return (
    <div className="layout">
      <div>
        <ProcessFaceRecognition
          {...props}
          faceMatcher={faceMatcher}
          facePhotos={facePhotos}
        />
      </div>
    </div>
  );
};
